export enum AdminDocumentType {
  ACO = "admin_aco",
  ADMIN = "admin",
  ADMIN_TRANSITION_CARE = "admin_transition_care",
  APCM = "admin_apcm",
  CASE_MANAGER_DOCUMENTS = "admin_case_manager_documents",
  CERTIFICATE_OF_MEDICAL_NECESSITY = "admin_certificate_of_medical_necessity",
  CREDENTIAL = "admin_credential",
  DEATH_CERTIFICATES = "admin_death_certificates",
  DISABILITY_FORMS = "admin_disability_forms",
  DOH_FORMS = "admin_doh_forms",
  FMLA_FORMS = "admin_fmla_forms",
  HEAD_START_PROGRAM = "admin_head_start_program",
  PATIENT_SHARED_INFORMATION = "admin_patient_shared_information",
  PFML_FORMS = "admin_pfml_forms",
  RESPONSE_FROM_OUTSIDE_PROVIDER_RECORD_NOT_FOUND = "admin_response_from_outside_provider_record_not_found",
  RETURN_TO_WORK = "admin_return_to_work",
  SCHOOL_NOTES = "admin_school_notes",
  RISK_ASSESSMENT = "admin_risk_assessment",
  WORK_OR_SCHOOL_PHYSICAL_FORMS = "admin_work_or_school_physical_forms",
  WORKERS_COMP = "admin_workers_comp",
  PHYSICIAN_ORDER = "order_from_physician",
  PATIENT_QUESTIONNAIRE = "admin_patient_questionnaire",
  PATIENT_QUESTIONNAIRE_VANDERBILT = "admin_patient_questionnaire_vanderbilt",
  LEAD_FORM = "admin_lead_form",
  OTHER = "admin_other",
  PATIENT_AUTHORIZATION = "admin_patient_authorization",
  PCP_ACKNOWLEDGEMENT_FORM = "admin_pcp_acknowledgement_form",
  POLST = "admin_polst",
  SOCIAL_DETERMINANTS = "admin_social_determinants",
  TRANSPORT_FORM = "admin_transport_form",
  GOVERNMENT_PROGRAM_FORMS = "admin_government_program_forms",
}

export enum BlankDocumentType {
  BLANK = "blank",
}

export enum CarePlanDocumentType {
  CARE_PLAN = "care_plan",
  REMINDER = "care_plan_reminder",
  IDT_ASSESSMENT = "care_plan_idt_assessment",
}

export enum CarePlanFollowUpAttempt {
  SECOND_ATTEMPT = "2nd Attempt",
  THIRD_ATTEMPT = "3rd Attempt",
  OTHER = "Other",
}

export enum ClearanceRequestDocumentType {
  CLEARANCE_REQUEST = "clearance_request",
  PRE_OP = "clearance_request_pre_op",
  SURGICAL = "clearance_request_surgical",
  RESPONSE = "clearance_request_response",
  RESPONSE_PRE_OP = "clearance_request_response_pre_op",
  RESPONSE_OTHER = "clearance_request_response_other",
}

export enum ConsentDocumentType {
  CONSENT = "consent",
}

export enum CoverPageDocumentType {
  COVER_PAGE = "cover_page",
}

export enum DmeDocumentType {
  DIABETIC_SUPPLIES = "dme_diabetic_supplies",
  DME_ORDER = "dme_order",
  DME_REQUEST = "dme_request",
  DME_RESPONSE = "dme_response",
}

export enum DmeOrderType {
  CMN = "CMN",
  SETUP = "Setup",
}

export enum EmergencySummaryDocumentType {
  EMERGENCY_SUMMARY = "emergency_summary",
}

export enum ProcedureCardiacType {
  ABLATION_REPORTS = "Ablation Reports",
  CATH_DIAGRAM = "Cath Diagram",
  CATH_REPORT = "Cath Report",
  CARDIOVERSION_REPORTS = "Cardioversion Reports",
  EP_STUDY_REPORTS = "EP Study Reports",
  PMK_INSERTION_REPORTS = "PMK Insertion Reports",
  TAVR = "TAVR",
}

export enum ProcedureDeviceType {
  DEVICE_IMPLANT_CARDS = "Device Implant Cards",
  MRI_COMPATIBILITY = "MRI Compatibility",
  PATIENT_STENT_CARDS = "Patient Stent Cards",
}

export enum FinancialDocumentType {
  BILLING_RECORDS = "financial_billing_records",
  ELIGIBILITY_OF_BENEFITS = "financial_eligibility_of_benefits",
  FINANCIAL = "financial",
  ELIGIBILITY_OF_BENEFITS_CREDIT_CARD = "financial_eligibility_of_benefits_credit_card",
  LEGAL = "financial_legal",
}

export enum IdentificationCardDocumentType {
  IDENTIFICATION_CARD = "identification_card",
}

export enum ImagingResultsDocumentType {
  BARIUM_SWALLOW = "imaging_results_barium_swallow",
  COLONOSCOPY = "imaging_results_colonoscopy",
  CT = "imaging_results_ct",
  DEXA = "imaging_results_dexa",
  ECHO = "imaging_results_echo",
  EEG = "imaging_results_eeg",
  EMG = "imaging_results_emg",
  ENG = "imaging_results_eng",
  EKG = "imaging_results_ekg",
  ESOPHAGRAM = "imaging_results_esophagram",
  HOLTER_MONITOR = "imaging_results_holter_monitor",
  IMAGING_RESULTS = "imaging_results",
  MAMMOGRAM = "imaging_results_mammogram",
  MULTI = "imaging_results_multi",
  MRI = "imaging_results_mri",
  NM = "imaging_results_nm",
  OTHER = "imaging_results_other",
  OTHER_CARDIAC = "imaging_results_cardiac",
  PET = "imaging_results_pet",
  PULMONARY_FUNCTION = "imaging_results_pulmonary_function",
  RETINAL = "imaging_results_retinal",
  STRESS_TEST = "imaging_results_stress_test",
  STRESS_TEST_EXERCISE = "imaging_results_stress_test_exercise",
  STRESS_TEST_NM = "imaging_results_stress_test_nm",
  ULTRASOUND = "imaging_results_ultrasound",
  X_RAY = "imaging_results_x_ray",
  NEEDS_CLARIFICATION = "imaging_results_needs_clarification",
  NEEDS_SIGNATURE = "imaging_results_needs_signature",
  ENDOSCOPY = "imaging_results_endoscopy",
  MONITOR_NOTIFICATION = "imaging_results_monitor_notification",
  CARDIAC_LEG_IMAGING = "imaging_results_cardiac_leg_imaging",
  CLINICAL = "imaging_results_clinical",
}

export enum IncompleteDocumentType {
  CANNOT_LINK_TO_PATIENT = "incomplete_cannot_link_to_patient",
  ILLEGIBLE = "incomplete_illegible",
  INCOMPLETE = "incomplete",
  NOT_ALL_PAGES = "incomplete_not_all_pages",
}

export enum InformationRequestDocumentType {
  INFORMATION_REQUEST = "information_request",
}

export enum InsuranceCardDocumentType {
  COMMUNICATION = "insurance_communication",
  INSURANCE_CARD = "insurance_card",
  LETTER_OF_ASSURANCE = "insurance_letter_of_assurance",
}

export enum IntakeDocumentType {
  INTAKE = "intake",
  INTAKE_DIALYSIS_QUESTIONAIRE = "dialysis_questionaire",
}

export enum JunkDocumentType {
  JUNK = "junk",
  FAILED_FAX = "junk_failed_fax",
}

export enum LabResultsDocumentType {
  A1C = "lab_results_a1c",
  BILIRUBIN = "lab_results_bilirubin",
  BP = "lab_results_bp",
  CBC = "lab_results_cbc",
  CMP = "lab_results_cmp",
  COLOGUARD = "lab_results_cologuard",
  DRUG_SCREEN = "lab_results_drug_screen",
  FIT = "lab_results_fit",
  HEARING_TEST = "lab_results_hearing_test",
  HEP = "lab_results_hep",
  LAB_RESULTS = "lab_results",
  LIPID_PANEL = "lab_results_lipid_panel",
  MICROALBUMIN = "lab_results_microalbumin",
  MULTIPLE_LABS = "lab_results_multiple_labs",
  ORDER_FORM = "lab_results_order_form",
  ORDER_FORM_NEEDS_SIGNATURE = "lab_results_order_form_needs_signature",
  OTHER = "lab_results_other",
  PAP_SMEAR = "lab_results_pap_smear",
  PATHOLOGY = "lab_results_pathology",
  PKU = "lab_results_pku",
  PT_INR = "lab_results_pt_inr",
  QUANTAFLO = "lab_results_quantaflo",
  TB = "lab_results_tb",
  TEST_NOT_PERFORMED = "lab_results_test_not_performed",
  URINALYSIS = "lab_results_urinalysis",
}

export enum LegalDocumentType {
  ADVANCED_CARE_DIRECTIVE = "legal_advanced_care_directive",
  COURT_DOCUMENTS = "legal_court_documents",
  GRIEVANCE = "legal_grievance",
  LEGAL = "legal",
  POWER_OF_ATTORNEY = "legal_power_of_attorney",
  SUBPOENA = "legal_subpoena",
}

export enum MedicalHistoryDocumentType {
  CHART_FROM_CLINIC = "medical_history_chart_from_clinic",
  CHART_FROM_HOSPITAL = "medical_history_chart_from_hospital",
  COVID = "medical_history_covid",
  HOME_HEALTH = "medical_history_home_health",
  HOSPICE = "medical_history_hospice",
  IMMUNIZATION = "medical_history_immunization",
  MEDICAL_HISTORY = "medical_history",
  RESPONSE = "medical_history_response",
  NUTRITION = "medical_history_nutrition",
  MEDICAL_HISTORY_MEDICATIONS = "medical_history_medications",
}

export enum MedicalRecordRequestDocumentType {
  DOH = "medical_record_request_doh",
  IMAGING_CD = "medical_record_request_imaging_cd",
  LEGAL = "medical_record_request_legal",
  MEDICAL_RECORD_REQUEST = "medical_record_request",
  MEDICAL_RECORD_REQUEST_HEDIS = "medical_record_request_hedis",
  OTHER = "medical_record_request_other",
  RESPONSE = "medical_record_request_response",
  SSA = "medical_record_request_ssa",
}

export enum NotificationDocumentType {
  HOSPITAL_ADMIT = "notification_hospital_admit",
  HOSPITAL_DISCHARGE = "notification_hospital_discharge",
  HOSPITAL_ER_ADMIT = "notification_hospital_er_admit",
  HOSPITAL_ER_DISCHARGE = "notification_hospital_er_discharge",
  HOSPITAL_FACE_SHEET = "notification_hospital_face_sheet",
  NOTIFICATION = "notification",
  APPOINTMENT_CANCELLED_MISSED = "notification_appointment_cancelled_missed",
  APPOINTMENT_OTHER = "notification_appointment",
  HOSPITAL_SDS_ADMIT = "notification_hospital_sds_admit",
  HOSPITAL_SDS_DISCHARGE = "notification_hospital_sds_discharge",
  EMAIL = "notification_email",
}

export enum OperationNoteDocumentType {
  OPERATION_NOTE = "operation_note",
}

export enum OtherDocumentType {
  OTHER = "other",
}

export enum VitalChartDocumentType {
  VITAL_CHART = "vital_chart",
}

export enum PharmacyRelatedDocumentType {
  CLARIFICATION = "pharmacy_related_clarification",
  CONTROLED_SUBSTANCES_POLICY = "pharmacy_related_controled_substances_policy",
  DRUG_MONITORING_PROGRAM = "pharmacy_related_drug_monitoring_program",
  NON_ADHERENCE = "pharmacy_related_non_adherence",
  MED_RECONCILIATION = "pharmacy_related_med_reconciliation",
  MEDICATION_LIST = "pharmacy_related_medication_list",
  PHARMACY_RELATED = "pharmacy_related",
  REFILL = "pharmacy_related_refill",
  REFILL_MANY = "pharmacy_related_refill_many",
  THERAPEUTIC_ALERT = "pharmacy_related_alert",
  CARE_CONSIDERATION = "pharmacy_related_care_consideration",
}

export enum PriorAuthorizationDocumentType {
  PRIOR_AUTHORIZATION = "prior_authorization",
  IMAGING_REQUEST = "prior_authorization_imaging_request",
  IMAGING_RESPONSE = "prior_authorization_imaging_response",
  MEDICATION_REQUEST = "prior_authorization_medication_request",
  MEDICATION_RESPONSE = "prior_authorization_medication_response",
  PROCEDURE_REQUEST = "prior_authorization_procedure_request",
  PROCEDURE_RESPONSE = "prior_authorization_procedure_response",
  REFERRAL_REQUEST = "prior_authorization_referral_request",
  REFERRAL_RESPONSE = "prior_authorization_referral_response",
  SURGERY_REQUEST = "prior_authorization_surgery_request",
  SURGERY_RESPONSE = "prior_authorization_surgery_response",
  THERAPY_REQUEST = "prior_authorization_therapy_request",
  THERAPY_RESPONSE = "prior_authorization_therapy_response",
}

export enum ProcedureDocumentType {
  CARDIAC = "procedure_cardiac",
  GI = "procedure_gi",
  SLEEP = "procedure_sleep",
  PROCEDURE = "procedure",
  REHAB = "procedure_rehab",
  CARDIAC_VEIN = "procedure_cardiac_vein",
  DEVICE_REQUEST = "procedure_device_request",
  DEVICE_INFO = "procedure_device_info",
  INVENTORY_LIST = "procedure_inventory_list",
}

export enum ProgressNoteDocumentType {
  CONTINUITY_OF_CARE = "progress_note_continuity_of_care",
  ER_REPORT = "progress_note_er_report",
  ER_SUMMARY = "progress_note_er_summary",
  FLOW_SHEET = "progress_note_flow_sheet",
  HOSPITAL_DISCHARGE_SUMMARY = "progress_note_hospital_discharge_summary",
  HOSPITAL_OFFICE_VISIT = "progress_note_hospital_office_visit",
  HOSPITAL_RECORDS = "progress_note_hospital_records",
  HOSPITAL_SUMMARY = "progress_note_hospital_summary",
  OFFICE_VISIT = "progress_note_office_visit",
  OPERATIVE_REPORT = "progress_note_operative_report",
  PRE_OPERATIVE = "progress_note_pre_operative",
  PROGRESS_NOTE = "progress_note",
  PT = "progress_note_pt",
  URGENT_CARE = "progress_note_urgent_care",
  VITAL_CHART = "progress_note_vital_chart",
}

export enum ReferralDocumentType {
  CONSENT_FOR_RECORDS_SPECIALIST = "consent_for_records_specialist",
  REFERRAL = "referral",
  REFERRAL_AUTH = "referral_auth",
  REFERRAL_OUTSIDE = "referral_outside",
  REFERRAL_REQUEST = "referral_request",
  REFERRAL_RESPONSE = "referral_response",
}

export enum ReferralStatusRequestDocumentType {
  REFERRAL_STATUS_REQUEST = "referral_status_request",
}

export enum ReferrerInformationDocumentType {
  REFERRER_INFORMATION = "referrer_information",
}

export enum ResponseToVhRequestDocumentType {
  RESPONSE_TO_VH_REQUEST = "response_to_vh_request",
}

export enum UnknownDocumentType {
  UNKNOWN = "unknown",
}

export enum OrderDocumentType {
  CARDIAC = "order_cardiac",
  LAB = "order_lab",
  CLARIFICATION = "order_clarification",
  IMAGING = "order_imaging",
  PROCEDURE = "order_procedure",
  SIGNED = "order_signed",
}
